import React from 'react';
import { Modal, Button, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGear } from '@fortawesome/free-solid-svg-icons';
import styles from './Title.module.css';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { dashboardActions } from '_actions';
class SettingsButton extends React.Component {
    constructor() {
        super();
        this.state = {
            showModal: false,
        };
    }

  // Open the modal
  handleOpenModal = () => {
    this.props.loadUserPreferences();
    this.setState({ showModal: true });
    }

    handleCloseModal = () => {
        this.setState({ showModal: false });
    }

    handleToggleChange = () => {
        this.props.saveUserPreferences(!this.props.openEvalPdf);
    }


  render(){
    return (
        <>
        {/* Gear Icon to open the modal */}
        <label title="Settings" className={styles.settings} onClick={this.handleOpenModal}>
            <FontAwesomeIcon icon={faGear} />
        </label>

        {/* Modal for Settings */}
        <Modal show={this.state.showModal} onHide={this.handleCloseModal} centered>
            <Modal.Header closeButton>
                <Modal.Title>User Preferences</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form>
                    <Form.Check
                        type="switch"
                        id="custom-switch"
                        label="Open PDF Eval"
                        checked={this.props.openEvalPdf}
                        onChange={this.handleToggleChange}
                    />
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={this.handleCloseModal}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    </>
      );
  }
 
};

function mapDispatchToProps(dispatch) {
    return {
        loadUserPreferences: bindActionCreators(dashboardActions.loadUserPreferences, dispatch),
        saveUserPreferences: bindActionCreators(dashboardActions.saveUserPreferences, dispatch),
    };
}

function mapStateToProps(state) {
    let openEvalPdf = state.entities.dashboard.openEvalPdf;

    return {
        openEvalPdf
    };
}


const connectedSettingsButton = connect(mapStateToProps, mapDispatchToProps)(SettingsButton);
export { connectedSettingsButton as SettingsButton };